export default __webpack_public_path__ + "static/media/gallery_05.a722506e.jpg";